import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'
import LandingPage from 'modules/LandingPage'
import { showLogin } from 'modules/UI/actions'
import { AuthPopupEnum } from 'utils/constants'
import { getLoginReturnUrl } from 'utils/loginRedirect'

const emptyRoles = []

const LoginPage = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const user = useSelector((s) => s.user)
  const userRoles = user.details?.userRoles || emptyRoles
  useEffect(() => {
    window.scrollTo(0, 0)
    if (!user.isFetching && !user.details) dispatch(showLogin(AuthPopupEnum.login))
  }, [dispatch, user.isFetching, user.details])

  const isBusiness = userRoles.includes('ROLE_BUSINESS')
  const adminWithoutBusiness = userRoles.includes('ROLE_ADMIN') && !user.details?.defaultBusinessId
  const redirectUrl = getLoginReturnUrl(location)

  if (userRoles.length > 0 && redirectUrl) {
    return <Navigate to={redirectUrl} replace />
  }

  if (isBusiness && !adminWithoutBusiness) {
    return <Navigate to="/business" replace />
  }

  if (userRoles.length > 0) {
    return <Navigate to="/" replace />
  }

  return <LandingPage />
}

export default LoginPage
